function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M27.29 38A19.47 19.47 0 007.84 57.48v2.8a.72.72 0 00.72.72h46.7a.9.9 0 00.9-.9v-2.62A19.47 19.47 0 0036.71 38zM32 30a13.52 13.52 0 1113.52-13.48A13.53 13.53 0 0132 30z",
  fill: "none",
  stroke: "currentColor",
  strokeMiterlimit: 10,
  strokeWidth: 5
});

function SvgProfile(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 64 64"
  }, props), _ref);
}

export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSI2NCIgaGVpZ2h0PSI2NCIgdmlld0JveD0iMCAwIDY0IDY0Ij48dGl0bGU+cHJvZmlsZTwvdGl0bGU+PHBhdGggZD0iTTI3LjI5LDM4QTE5LjQ3LDE5LjQ3LDAsMCwwLDcuODQsNTcuNDh2Mi44YS43Mi43MiwwLDAsMCwuNzIuNzJINTUuMjZhLjkuOSwwLDAsMCwuOS0uOVY1Ny40OEExOS40NywxOS40NywwLDAsMCwzNi43MSwzOFoiIGZpbGw9Im5vbmUiIHN0cm9rZT0iY3VycmVudENvbG9yIiBzdHJva2UtbWl0ZXJsaW1pdD0iMTAiIHN0cm9rZS13aWR0aD0iNSIvPjxwYXRoIGQ9Ik0zMiwzMEExMy41MiwxMy41MiwwLDEsMSw0NS41MiwxNi41MiwxMy41MywxMy41MywwLDAsMSwzMiwzMFoiIGZpbGw9Im5vbmUiIHN0cm9rZT0iY3VycmVudENvbG9yIiBzdHJva2UtbWl0ZXJsaW1pdD0iMTAiIHN0cm9rZS13aWR0aD0iNSIvPjwvc3ZnPg==";
export { SvgProfile as ReactComponent };